import { AdditionalServicesService } from '../services/additional_services.service'
import {
    AdditionalServicesTypesList,
    UpdateAdditionalServicesPayloadT,
} from '../types/additional_services.types'

const additionalServicesService = new AdditionalServicesService()

class AdditionalServicesRealisation {
    getList(): Promise<AdditionalServicesTypesList> {
        return additionalServicesService.getList()
    }

    updateInvoiceAdditionalServices(
        invoice_id: number,
        payload: UpdateAdditionalServicesPayloadT
    ): Promise<void> {
        return additionalServicesService.updateInvoiceAdditionalServices(invoice_id, payload)
    }

    updateOrderAdditionalServices(
        order_id: number,
        payload: UpdateAdditionalServicesPayloadT
    ): Promise<void> {
        return additionalServicesService.updateOrderAdditionalServices(order_id, payload)
    }
}

export const additionalServices = new AdditionalServicesRealisation()
